import styled from "styled-components";
import { vwDesktop, vwMobile } from "../../helpers/styles";
import { BREAKPOINTS } from "../../helpers/theme";
import { Tabs } from "../Tabs";
import ReactPlayer from "react-player";

export const Container = styled.div<{ backgroundColor?: string }>`
  padding: ${vwMobile(40)} ${vwMobile(20)};
  background-color: ${(p) =>
    p.backgroundColor ?? "#033305"};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    padding: ${vwDesktop(20)} ${vwDesktop(150)} ${vwDesktop(20)};
  }
`;

export const HtmlContainer1 = styled.div<{
  backgroundColor?: string;
}>`
  padding: ${vwMobile(40)} ${vwMobile(18)};
  background-color: ${(p) =>
    p.backgroundColor ?? "#033305"};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    padding: ${vwDesktop(80)} ${vwDesktop(150)} ${vwDesktop(80)};
  }
`;

export const HtmlContainer2 = styled.div<{
  backgroundColor?: string;
}>`
  padding: ${vwMobile(40)} ${vwMobile(18)};
  background-color: ${(p) =>
    p.backgroundColor ?? "#033305"};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    padding: ${vwDesktop(80)} ${vwDesktop(310)};
  }
`;

export const StyledReactPlayer = styled(ReactPlayer)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100% !important;
  height: 100% !important;
`;

export const ReactPlayerContainer = styled.div`
  width: 100%;
  padding-top: 56.25%;
  position: relative;
  margin-bottom: ${vwMobile(77)};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    margin-bottom: 0;
  }
`;

export const StyledTabs = styled(Tabs)`
  padding: 0 0 ${vwMobile(80)};

  && {
    background-color: transparent;
  }

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    padding: 0 0 ${vwDesktop(120)};
  }

  .tab-container {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    gap: ${vwMobile(20)};
    background: transparent;
    padding: 0 0 ${vwMobile(40)};
    width: 100%;

    @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
      padding: 0 0 ${vwDesktop(64)};
    }
  }
`;

export const AccordionContainer = styled.section``;

export const BlogHeroWrapper = styled.div`
  background-color: #033305;
  & > div {
    margin-bottom: ${vwMobile(0)};
  }

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    padding: 0 0 ${vwDesktop(100)} ${vwDesktop(100)};
  }
`;
